"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var __1 = require("..");
var util_localization_1 = __importStar(require("@sport-thieme/util-localization"));
util_localization_1.default.addTranslations('de', { 'No options': 'Kein Suchfilter vorhanden' });
exports.default = react_1.forwardRef(function ChipAutocomplete(_a, ref) {
    var uncontrolledSearch = _a.search, onSearchChange = _a.onSearchChange, onChange = _a.onChange, options = _a.options, onCreate = _a.onCreate, _b = _a.noOptionsText, noOptionsText = _b === void 0 ? util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["No options"], ["No options"]))) : _b, _c = _a.size, size = _c === void 0 ? 'medium' : _c, defaultTextFieldProps = _a.defaultTextFieldProps, chipProps = _a.chipProps, _d = _a.limitTags, limitTags = _d === void 0 ? -1 : _d, value = _a.value, _e = _a.openOnFocus, openOnFocus = _e === void 0 ? false : _e, rest = __rest(_a, ["search", "onSearchChange", "onChange", "options", "onCreate", "noOptionsText", "size", "defaultTextFieldProps", "chipProps", "limitTags", "value", "openOnFocus"]);
    var _f = react_1.useState(uncontrolledSearch || ''), search = _f[0], setSearch = _f[1];
    var _g = react_1.useState(false), open = _g[0], setOpen = _g[1];
    var handleSearchChange = function (val) {
        setSearch(function () { return val; });
        onSearchChange === null || onSearchChange === void 0 ? void 0 : onSearchChange(val);
    };
    react_1.useEffect(function () {
        if (typeof uncontrolledSearch === 'string') {
            setSearch(uncontrolledSearch);
        }
    }, [uncontrolledSearch]);
    react_1.useEffect(function () {
        setOpen(search.length > 0);
    }, [search]);
    if (rest.variant === 'filled' && rest.label !== undefined) {
        chipProps = __assign(__assign({}, chipProps), { size: 'small' });
    }
    if (size === 'small' && (defaultTextFieldProps === null || defaultTextFieldProps === void 0 ? void 0 : defaultTextFieldProps.margin) === undefined) {
        defaultTextFieldProps = __assign(__assign({}, defaultTextFieldProps), { margin: 'dense' });
    }
    var handleChange = function (_event, changedValue, reason) {
        if (reason !== 'create-option') {
            onChange === null || onChange === void 0 ? void 0 : onChange(changedValue.map(function (opt) {
                if (typeof opt === 'string') {
                    return opt;
                }
                else if ('value' in opt) {
                    return opt.value;
                }
                return opt[0];
            }));
        }
        else if (reason === 'create-option') {
            var newValue = changedValue.pop();
            if (value.includes(newValue) === false) {
                onCreate === null || onCreate === void 0 ? void 0 : onCreate(newValue);
            }
            if (onCreate !== undefined) {
                setSearch('');
            }
        }
    };
    var handleFocus = function () {
        if (openOnFocus) {
            setOpen(true);
        }
    };
    var handleBlur = function () {
        setOpen(false);
    };
    var filterOptions = function (opts) {
        return opts
            .filter(function (opt) { return value.includes(opt.value) === false; })
            .filter(function (opt) {
            return search ? opt.label.toLocaleLowerCase().includes(search.toLocaleLowerCase()) : true;
        });
    };
    return (jsx_runtime_1.jsx(__1.Autocomplete, __assign({ multiple: true, options: options, value: value.map(function (val) { return options.find(function (opt) { return opt.value === val; }); }), onChange: handleChange, size: size, freeSolo: true, chipProps: chipProps, defaultTextFieldProps: defaultTextFieldProps, inputValue: search, limitTags: limitTags, filterOptions: filterOptions, noOptionsText: noOptionsText, open: open, onFocus: handleFocus, onBlur: handleBlur, openOnFocus: openOnFocus, onInputChange: function (_event, value, reason) {
            if (reason === 'reset')
                return;
            handleSearchChange(value);
        }, getOptionLabel: function (opt) {
            if (typeof opt === 'string') {
                return opt;
            }
            return opt && opt.label;
        } }, rest, { ref: ref }), void 0));
});
var templateObject_1;
//# sourceMappingURL=ChipAutocomplete.js.map